<bl-page-card-container
  data-smartpresentation="container-pagina"
  id="rps-prestadores-odontologicos"
  backNavigation=".."
  [showTooltip]="true"
  [tooltipKey]="pageTooltip"
  (onCopyUrlFilters)="onCopyUrlFilters()"
>
  <ng-container header>
    <div class="flex align-items-center">
      <ag-views-toolbar [grid]="agGrid" [gridKey]="GRID_KEY" class="mr-2"></ag-views-toolbar>

      <bl-competencia
        class=" mr-2"
        [competencia]="competenciaRange[0]"
        [competenciaFinal]="competenciaRange[1]"
        (apply)="competenciaChanged($event)"
      ></bl-competencia>

      <div class="flex align-items-center mr-2">
        <p-select size="small"
          class=""
          optionLabel="label"
          optionValue="value"
          [options]="registroRpsOptions"
          [(ngModel)]="selectedRegistroRps"
          dropdownIcon="pi pi-angle-down"
          placeholder="Situação no RPS"
          (ngModelChange)="onRegistroRpsChange()"
          [showClear]="true"
          [style]="{ width: '260px', height: '35.38px' }"
          appendTo="body"
        ></p-select>
      </div>

      <button
        data-smartpresentation="botao-pesquisar"
        pButton
        type="button"
        icon="pi pi-search"
        iconPos="left"
        label="Pesquisar"
        class="mr-4 p-button p-button-md"
        [ngClass]="{ 'p-disabled': !filterChanged }"
        (click)="reloadData()"
      ></button>

      <button
        class="p-button p-button-outlined p-button-icon-only ml-2"
        (click)="exportExcel()"
        pTooltip="Exportar Listagem como XLSX"
        tooltipPosition="bottom"
        [disabled]="!rowData?.length"
      >
        <i class="pi pi-file-excel"></i>
      </button>
      <button
        data-smartpresentation="botao-tela-cheia"
        class="p-button p-button-outlined p-button-icon-only ml-2"
        (click)="toggleFullscreen()"
        pTooltip="Tela Cheia"
        tooltipPosition="bottom"
      >
        <i
          class="pi"
          [ngClass]="{ 'pi-window-maximize': !(fullscreen$ | async), 'pi-window-minimize': (fullscreen$ | async) }"
        >
        </i>
      </button>
    </div>
  </ng-container>

  <div class="flex flex-column flex-1 min-h-0">
    <ag-grid-angular
      #agGrid
      data-smartpresentation="ag-grid"
      class="ag-theme-balham w-full"
      [style.height]="gridHeight$ | async"
      [rowData]="rowData"
      [gridOptions]="gridOptions"
      [overlayLoadingTemplate]="firstLoad ? 'Clique em Pesquisar para exibir os registros' : null"
    >
    </ag-grid-angular>
  </div>
</bl-page-card-container>
